export enum UserGroup {
  OWNER = 'OWNER',
  BROKER = 'BROKER',
  INTERESTED = 'INTERESTED',
  OTHER = 'OTHER',
  EMPTY = 'EMPTY'
}
